<template>
  <div style="margin: 10px">
    <v-form>
      <v-card>
        <div class="headline dialog-header" v-if="showDialogHeader">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px"
            >{{ $t(formName) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        <v-card-text>
           <v-layout>
            <v-flex>
              <table class="lstTable">
                <tr>
                    <th>{{$t('lang.material.materialType')}}</th>
                    <th>Tên vật tư</th>
                    <th width="200">Đơn vị</th>
                    <th width="200">Tồn kho</th>
                    <th width="200">Số lượng cần xuất</th>
                    <th width="200" v-if="isDirector">Đơn giá</th>
                    <th width="200" v-if="isDirector">Thành tiền</th>
                </tr>
                <template v-for="(item, index) in lstMaterial">
                    <tr v-if="item.row === 0" :key="'mat'+index">
                        <td style="font-weight: bold">{{item.typeName}}</td>
                        <td colspan="7">Không có vật tư</td>
                    </tr>
                    <tr v-else :key="'mat'+index">
                        <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0" style="font-weight: bold">{{item.typeName}}</td>
                        <td>{{ item.materialName }}</td>
                        <td style="text-align: center">{{ item.unit }}</td>
                        <td style="text-align: center">{{ item.inventory | currency }}</td>
                        <td style="text-align: center">{{ item.total_export | currency }}</td>
                        <td style="text-align: center" v-if="isDirector">{{ item.price != undefined ? item.price : 0 | currency }}</td>
                        <td style="text-align: center" v-if="isDirector">{{ item.amount != undefined ? item.amount : 0 | currency }}</td>
                    </tr>
                </template>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn v-if="showApprove" color="success" @click="onApprove" :disabled="loading">
            {{ $t("Phê duyệt tất cả") }}
          </v-btn>
          <v-btn v-if="showReject" color="error" @click="onRejectApprove" :disabled="loading">
            {{ $t("Không phê duyệt tất cả") }}
          </v-btn>
          <v-btn v-if="showConfirm" color="success" @click="onConfirm" :disabled="loading">
            {{ $t("Xác nhận tất cả") }}
          </v-btn>
<!--          <v-btn v-if="showRejectConfirm" color="error" @click="onRejectApprove" :disabled="loading">-->
<!--            {{ $t("Không xác nhận tất cả") }}-->
<!--          </v-btn>-->

          <v-btn v-if="showPrint" color="info" @click="onPrint" :disabled="loading">
            {{ $t("In phiếu") }}
          </v-btn>
          <v-btn color="warning" @click="onCancel" :disabled="loading">
            {{ $t("lang.common.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import {areaContants, roleConstants} from "@/constants";

export default {
  name: "NotProcessSummaryView",
  components: {IDatepicker},
  props: {
    valuesProp: {
      type: Object,
      default: ()=> {}
    },
    showDialogHeader: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      values: {
        areaId: "-1",
        exportDate: ""
      },
      exportIdIn: "-1",
      formName: "Tổng hợp đề nghị xuất kho",
      loading: false,
      roleGroup: 2,
      warehouseCode: "",
      warehouseId: '',
      cropCode: '',
      areaCode: '',
      procedureCode: '',
      famerName: '',
      timeAmSelected: [],
      timePmSelected: [],
      numberGList: areaContants.numberGList,
      lstG: [],
      timeAm: [],
      timePm: [],
      materials: [],
      lstSupplier: [],
      lstMaterialType: [],
      lstMaterialTmp: [],
      lstMaterial: [],
      lstImportWh: [],
      lstUser: [],
      lstProcedureData: [],
      requestOrder: null,
      isDisabled: false,
      role: '',
      exportRequest: '',
      createItem: {
        requestNumber: '',
        userCreateId: '',
        userCreateName: '',
        cropId: '',
        numberG: 1,
        exportType: 1,
        shrimpAge: '',
        status: 0,
      },
    };
  },

  created() {
    if(this.valuesProp != undefined
        && this.valuesProp.areaId!= undefined && this.valuesProp.areaId!= ""
        && this.valuesProp.status!= undefined  && this.valuesProp.status!= ""
        && this.valuesProp.requestDate!= undefined  && this.valuesProp.requestDate!= ""
    ){
      this.values.areaId = this.valuesProp.areaId;
      this.values.exportDate = this.valuesProp.exportDate;
      this.values.status = this.valuesProp.status;
      this.values.materialTypeAllyId = this.valuesProp.materialTypeAllyId;
    } else if(this.$route.params.areaId != undefined && this.$route.params.areaId !=""
        && this.$route.params.requestDate != undefined && this.$route.params.requestDate !=""
        && this.$route.params.status != undefined && this.$route.params.status !=""){
      this.values.areaId = this.$route.params.areaId;
      this.values.exportDate = this.$route.params.requestDate;
      this.values.status = this.$route.params.status;
      this.values.materialTypeAllyId = this.$route.params.materialTypeAllyId;
    }
  },
  computed: {
    isDirector() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
        return true;
      } else {
        return false;
      }
    },
    showApprove() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
        return true;
      } else {
        return false;
      }
    },
    showReject() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
        return true;
      } else {
        return false;
      }
    },
    // showRejectConfirm() {
    //   if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    showConfirm () {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.created) {
        return true;
      } else {
        return false;
      }
    },
    showPrint () {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
          || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.approved) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    valuesProp: {
      handler(value) {
        this.values.areaId = value.areaId;
        this.values.exportDate = value.exportDate;
        this.values.status = value.status;
        this.values.materialTypeAllyId = value.materialTypeAllyId;
      },
      deep: true
    },
    values: {
      handler(value) {
          let tempValue = Object.assign({}, value, {"exportType": 2})
          this.getPondArea(value.areaId);
          this.getExportRequestSummaryApprove(tempValue);

        // if(this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR){
        //   let tempValue = Object.assign({}, value, {"status": 2})
        //   this.getPondArea(value.areaId);
        //   this.getExportRequestSummaryApprove(tempValue);
        // } else if(this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER){
        //   let tempValue = Object.assign({}, value, {"status": 1})
        //   this.getPondArea(value.areaId)
        //   this.getExportRequestSummaryApprove(tempValue);
        // }
      },
      deep: true
    },
  },

  methods: {
    onCancel() {
      this.$router.push({path: '/exportRequest'});
    },
    onCancelExport() {
      this.loading = true;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/reject", this.exportRequest)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onApprove() {
      this.loading = true;
      const params = this.values;
      params.exportType = 2;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/approveList", params)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },

    onConfirm() {
      this.loading = true;
      const params = this.values;
      params.exportType = 2;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/confirmList", params)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },

    onRejectApprove(reason = '') {
      this.loading = true;
      const params = this.values;
      params.exportType = 2;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/rejectList", params)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onPrint() {
      this.values.exportType=2;
      axios({
        url: process.env.VUE_APP_API_URL + "/exportRequest/exportExcelSummary",
        method: "POST",
        data: this.values,
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "De_nghi_xuat_kho_tong_hop" + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    getExportRequestSummaryApprove(values) {
      if (values.areaId != -1) {
        const params = values;
        params.exportType = 2;
        axios
            .post(
                process.env.VUE_APP_API_URL + "/exportRequest/searchSummaryApprove?pageSize=-1&page=-1",
                params
            )
            .then((data) => {
              if (data.items && data.items.length > 0) {
                const exportRequest = data.items[0];
                // console.log("exportRequest1", exportRequest);
                exportRequest.exportDate = moment(String(exportRequest.exportDate)).format('YYYY-MM-DD');
                this.lstMaterial = JSON.parse(exportRequest.requestData);
                console.log("lstMaterial", this.lstMaterial);
                this.exportRequest = exportRequest;
                if (exportRequest.status != 1 && this.roleGroup == 1) {
                  this.isDisabled = true;
                }
                // this.getMaterialPrice();
              }
            });
      }
    },
    getCrop(cropId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1",
          {cropId: cropId}
      )
          .then((data) => {
            if (data.items) {
              this.cropCode = data.items[0].code;

              // this.getEnvMeasure();
              // this.getPondArea(data.items[0].pondAreaId);
              this.getUser(data.items[0].users);
              // this.getShrimpAge(data.items[0]);
              this.getProcedureDetail(data.items[0].processId);
            }
          });
    },
    getPondArea(areaId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=PONDAREA&pageSize=-1&page=-1",
          {categoryId: areaId}
      )
          .then((data) => {
            if (data.items) {
              this.areaCode = data.items[0].categoryName;
              this.getWarehouse(data.items[0].categoryId);
            }
          });
    },
    getWarehouse(parentId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=WAREHOUSE&pageSize=-1&page=-1",
          {parentId: parentId}
      )
          .then((data) => {
            if (data.items) {
              this.warehouseId = data.items[0].categoryId;
              this.getWarehouseInventory(data.items[0].categoryId);
            }
          });
    },
    getWarehouseInventory(warehouseId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/warehouse/search?pageSize=-1&page=-1",
          {warehouseId: warehouseId}
      )
          .then((data) => {
            if (data.items) {
              this.lstInventory = data.items;
              this.calcuInventory();
            }
          });
    },
    // setMaterialInventory(data) {
    //     console.log(this.lstMaterial);
    //     $.each(this.lstMaterial, function (k, v) {

    //     });
    // },
    getProcedureDetail(procedureId) {
      axios.post(process.env.VUE_APP_API_URL + "/procedureWh/detail/" + procedureId,
          {numberG: this.createItem.numberG}
      ).then(
          data => {
            this.procedureCode = data.procedureWh.code;
            // this.lstProcedureData = data;
            // this.reCalculate();
          }
      )
    },
    getUser(stringUser) {
      const uArr = stringUser.split(",");
      axios.post(
          process.env.VUE_APP_API_URL + "/user/list", {}
      )
          .then((data) => {
            if (data.content.length > 0) {
              const lstUser = data.content;
              const famers = lstUser.filter(function (e) {
                return uArr.indexOf(String(e.userId)) != -1;
              });
              if (famers) {
                let listUser = ''
                $.each(famers, function (k, v) {
                  if (k == 0) {
                    listUser += v.fullName;
                  } else {
                    listUser += ", " + v.fullName;
                  }
                });
                this.famerName = listUser;
              }
            }
          });
    },
    getImportWh(reqOrdId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/importWh/search?pageSize=-1&page=-1",
          {status: 1, reqOrdId: reqOrdId}
      )
          .then((data) => {
            if (data.items) {
              this.lstImportWh = data.items;
            }
            this.calcTotalImportQuantity();
          });
    },
    getMaterialType() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE"
      ).then(
          (data) => {
            if (data.length > 0) {
              this.lstMaterialType = data;
            }
          }
      );
    },
    reCalculate() {

      //
      // sum
      //
      this.lstMaterial = [];
      for (let i = 0; i < this.lstProcedureData.lstMaterial.length; i++) {
        this.lstMaterial.push(Object.assign({}, this.lstProcedureData.lstMaterial[i]));
      }

      for (let i = 0; i < this.lstMaterial.length; i++) {
        this.lstMaterial[i].total = 0;

        for (let j = 0; j < this.lstProcedureData.lstChildrenDay.length; j++) {
          let procedureDay = this.lstProcedureData.lstChildrenDay[j];
          if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
            if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
              continue;
            }
            let data = JSON.parse(procedureDay.data);
            let count = data[this.lstMaterial[i].materialId];
            if (count != undefined && count != null && count != "") {
              this.lstMaterial[i].total += parseFloat(count);
            }
          }
        }
        for (let j = 0; j < this.lstProcedureData.lstMotherDay.length; j++) {
          let procedureDay = this.lstProcedureData.lstMotherDay[j];
          if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
            if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
              continue;
            }
            let data = JSON.parse(procedureDay.data);
            let count = data[this.lstMaterial[i].materialId];
            if (count != undefined && count != null && count != "") {
              this.lstMaterial[i].total += parseFloat(count);
            }
          }
        }
      }
      //
      // remove item has total = 0 and not in material type
      //
      for (let i = this.lstMaterial.length - 1; i >= 0; i--) {
        if (this.lstMaterial[i].total == 0) {
          this.lstMaterial.splice(i, 1);
          continue;
        }
        let bRemove = true;
        for (let j = 0; j < this.lstMaterialType.length; j++) {
          if (this.lstMaterialType[j].categoryId == this.lstMaterial[i].typeId) {
            bRemove = false;
            break;
          }
        }
        if (bRemove) {
          this.lstMaterial.splice(i, 1);
        }
      }
      //
      // sort by typeId
      //
      this.lstMaterial.sort((o1, o2) => {
        if (o1.typeId == o2.typeId) {
          return o1.materialName.localeCompare(o2.materialName);
        } else {
          return o1.typeId - o2.typeId;
        }
      })

      for (let i = 0; i < this.lstMaterialType.length; i++) {
        this.lstMaterialType[i].count = 0;
        for (let j = 0; j < this.lstMaterial.length; j++) {
          if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
            this.lstMaterialType[i].count++;
          }
        }
        if (this.lstMaterialType[i].count == 0) {
          this.lstMaterial.push({
            typeId: this.lstMaterialType[i].categoryId,
            typeName: this.lstMaterialType[i].categoryCode,
            row: 0
          })
        } else {
          for (let j = 0; j < this.lstMaterial.length; j++) {
            if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
              this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryCode;
              this.lstMaterial[j].row = this.lstMaterialType[i].count;
              break;
            }
          }
        }

      }

      // filter total > 0
      this.lstMaterial = this.lstMaterial.filter(function (e) {
        return e.total != undefined && e.total > 0;
      });

      // inventory
      // const lstInventory = this.lstInventory;
      // const lstMaterial = this.lstMaterial;
      // for (let i = lstMaterial.length - 1; i >= 0; i--) {
      //   lstMaterial[i].quantityAm = [];
      //   lstMaterial[i].quantityPm = [];
      //   lstMaterial[i].total_export = 0;
      //   if (lstMaterial[i].inventory == undefined) {
      //       lstMaterial[i].inventory = 0;
      //   }
      // }
      // this.lstMaterial = lstMaterial;
    },
    // getMaterialPrice() {
    //     axios.post(
    //         process.env.VUE_APP_API_URL + "/materialPrice/search?pageSize=-1&page=-1", {}
    //     )
    //         .then((data) => {
    //             if (data.items) {
    //                 this.lstMaterialPrice = data.items;
    //                 this.calcuPrice();
    //             }
    //         });
    // },
    calcuPrice() {
        for(let i = 0; i< this.lstMaterial.length; i++){
            let obj = this.lstMaterial[i];
            const matPrice = this.lstMaterialPrice.find((v) => v.materialId === obj.materialId);
            if (matPrice != undefined) {
                obj.price = matPrice.averagePrice;
                obj.amount = obj.total_export * obj.price;
            }
        }
    },
  },
  destroyed() {
  },
};
</script>
